import { styled } from '@stitches/react'
import { gray15 } from '../platform/color'

// TODO: Delete and replace in favor of modular text or header component
export const Title = styled('h1', {
  fontSize: '22px',
  lineHeight: '28px',
  fontWeight: 700,
  color: gray15,
  marginBottom: '8px'
})
